import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IDatasource, GridApi, GridOptions, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { ProjectDto } from 'projects/shared/src/lib/models/Project';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { AgGridTenantUsersSettings } from '../tenant-users/AgGridTenantUsersSettings';
import { AgGridTenantProjectsSettings } from './AgGridTenantProjectsSettings';
import { PermissionsService } from 'projects/shared/src/lib/services/permissions.service';

@Component({
  selector: 'tenant-projects',
  templateUrl: './tenant-projects.component.html',
  styleUrls: ['./tenant-projects.component.scss']
})
export class TenantProjectsComponent implements OnInit {

  @Input('tenant') tenant!:TenantDto;
  rowData: ProjectDto[] = [];

  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridTenantProjectsSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  emptyProjId = '00000000-0000-0000-0000-000000000000';


  constructor(private route: ActivatedRoute,
    public translate:TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    private permissionService: PermissionsService) { }

  ngOnInit(): void {
    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridTenantProjectsSettings(this.translate);

    this.frameworkComponents = {
      //buttonRenderer: UsersButtonRendererComponent
    }

    //this.gridOptions = agGridUsersSettings;
    this.gridOptions = this.aggridSettings.agGridTenantProjectsSettings;

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'TenantProject';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        // hier muss ein neuer Tenant Application Token erzeugt werden, weil "SM" erst jetzt in einen Tenant gewechselt ist
//        if (this.tenantService.getToken == null || this.tenantService.getToken == "") {
          this.tenantService.currentTenantId = this.tenant.id;
          this.getTenantProjects(params);
          // this.tenantService.createApplicationToken(this.tenant.name, this.emptyProjId).subscribe({
          //   next: (appToken) => {
          //     console.log("tenant-projects new ApplicationToken: ", appToken);
          //     this.tenantService.storeToken(appToken);
          //     this.getTenantProjects(params);
          //   },
          //   error: () => {
          //     this.notificationService.error(`${this.translate.data["ERROR"]}`, "createApplicationToken error")
          //   }
          // })
        // } else
        //   this.getTenantProjects(params);
    


      }
    }
  }

  getTenantProjects(params: IGetRowsParams) {
    this.tenantService.getTenantProjects(this.tenant.name, this.filter).subscribe({
      next: (projects) => {
        this.rowData = projects;
        //console.log("-----> getTenantProjects", this.rowData)
        this.rowData = this.rowData.slice(params.startRow, params.endRow);
        let lastRow = -1;

        if (projects.length <= params.endRow) {
          lastRow = projects.length;
        }
        params.successCallback(this.rowData, lastRow);
         // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        this.resultsLength = this.rowData.length;

        this.gridApi.hideOverlay();
      
        //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERSRETRIEVED"]}`);
      },
      error: (error: any) => {
        this.isLoadingResults = false;
        // Catch if the Squirrel API has reached its rate limit. Return empty data.
        this.isRateLimitReached = true;
        this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERRETRIVALERROR"]}`)
      }
    })
}

  onGridReady(params: any) {
    this.gridApi = params.api;    
    this.gridApi.sizeColumnsToFit();    
    this.gridApi.setDatasource(this.ds)
  }

}
